module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter2"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005toc#ch2"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('strong', [_vm._v("CHOCOLATE-PEANUT")]), _vm._v(" CLUSTERS")])])]), _vm._v(" "), _c('div', {
    staticClass: "floatleft"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/img-018.jpg",
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES ABOUT 60 CLUSTERS")])]), _vm._v(" "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/img-014.jpg"
    }
  }), _vm._v(" Melanie Loving has been with the University of Texas Medical Branch cookie-swap group since its inception. “Being a part of it is the perfect way to outfit my holiday table with all types of cookies and candies,” she says. In the case of this one, you only need your microwave to make it. Here’s to her being one smart cookie.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_vm._v("One 1-pound package chocolate- or vanilla-almond bark")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("One 12-ounce bag milk chocolate chips")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("One 8-ounce can salted peanuts, or more as desired")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MICROWAVE")])]), _vm._v(" the almond bark in a microwave-safe bowl at high power for 3½ minutes (the bark will not lose its form). Remove and stir to melt the bark. Add the chocolate chips and stir. Add the peanuts and stir.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("DROP")])]), _vm._v(" the mixture by teaspoonfuls onto wax paper. Let them cool until they set. Store, covered, at cool room temperature for about 1 week.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cc669bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009chapter2.vue
// module id = 81
// module chunks = 0